// @flow

import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { setCurrentPlace } from '../../redux/actionsCreators';
import type { PlaceType } from '../../api/types';
import type { DefaultStateType } from '../../redux/reducers';

import styles from './styles.scss';

import LA from '../../assets/image/LA.jpg';
import NY from '../../assets/image/NY.jpg';
import videoMp4 from '../../assets/video.mp4';
import videoWebm from '../../assets/video.webm';

import { fadeInUp, fadeInDown, fadeInRight, fadeInCentre, preloader, animateMenuItems } from '../../utils/animation';
import classnames from 'classnames';

type Props = {
  currentPlace: PlaceType,
  setCurrentPlace: (currentPlace: PlaceType) => void,
};

class Home extends React.Component<Props> {
  componentDidMount() {
    this.runPreloader();

    if (document && document.body) {
      document.body.classList.add('home');
    }
  }

  componentWillUnmount() {
    if (document && document.body) {
      document.body.classList.remove('home');
    }
  }

  runPreloader = () => {
    const callback = () => {
      if (window.innerWidth > 992) {
        fadeInUp('[data-animation="top"]');
        fadeInDown('[data-animation="bottom"]');
        fadeInRight('[data-animation="fadeInRight"]');
        fadeInCentre('[data-animation="width"]');
      }

      if (window.innerWidth > 768) {
        animateMenuItems().play();
      }
    };

    preloader(callback).play();
  };

  handleLinkClick = (page: string) => () => {
    if (this.props.places) {
      const defaultPlace = this.props.places.find(p => p.name.toLowerCase() === 'los angeles');

      if (defaultPlace) {
        this.props.setCurrentPlace(defaultPlace);
      }
    }

    this.props.history.push(`/${page}`);
  };

  render(): React.Element<'div'> {
    return (
      <div className={styles.container}>
        <div className={styles.animation}>
          <video id="video" className="video" autoPlay={true} loop={true} muted={true} playsInline={true}>
            <source src={videoWebm} type="video/webm" />
            <source src={videoMp4} type="video/mp4" />
          </video>
          <div id="cityImg">
            <img id="imgLA" src={LA} alt="los angeles" />
            <img id="imgNY" src={NY} alt="new york" />
          </div>
        </div>
        <h1 data-animation="top">Centerstaging</h1>
      </div>
    );
  }
}

const mapStateToProps = (state: DefaultStateType): { currentPlace: PlaceType } => ({
  currentPlace: state.currentPlace,
  places: state.places,
});

const mapDispatchToProps = (dispatch): Object => ({
  setCurrentPlace(currentPlace) {
    dispatch(setCurrentPlace(currentPlace));
  },
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(Home),
);



// WEBPACK FOOTER //
// ./src/pages/Home/index.js